export type UpdateRootComponentsDeletionFlagsRequest = {
  rootCpntList: UpdateRootComponentDeletionFlags[];
};
export type UpdateRootComponentDeletionFlags = {
  index: number;
  dipByRgn: string;
  rootCpntId: string;
  delFlg: string;
  updateDateTime: string;
};
